import React from 'react';
import { Button, Text } from '@bufferapp/ui';
import useDismissBanner, {
  BannerTypes,
} from '~/profile-page/hooks/useDismissBanner';
import {
  useAccount,
  useDismissedBanners,
  useChannelsConnected,
} from '~/accountContext';
import { Badge } from './components/Badge';

import * as Styles from './styles';
import { Layout } from '../styles';

export const ConnectYoutubeChannelBanner = (): JSX.Element | null => {
  const dismissedBanners = useDismissedBanners();

  const { onDismissBanner } = useDismissBanner({
    banner: BannerTypes.connectYoutubeChannel,
  });

  const onDismissClicked = () => {
    onDismissBanner();
  };

  const channelsConnected = useChannelsConnected();
  const account = useAccount();

  const isOneBufferOrg =
    account?.account?.currentOrganization?.isOneBufferOrganization;

  const alreadyDismissed =
    dismissedBanners &&
    dismissedBanners.includes(BannerTypes.connectYoutubeChannel);

  const hasNotConnectedYoutube = !channelsConnected.includes('youtube');
  const hasTikTokChannelConnected = channelsConnected.includes('tiktok');
  const hasInstagramChannelConnected = channelsConnected.includes('instagram');

  const showBanner =
    isOneBufferOrg &&
    !alreadyDismissed &&
    hasNotConnectedYoutube &&
    (hasTikTokChannelConnected || hasInstagramChannelConnected);

  if (!showBanner) return null;

  return (
    <Layout
      dismiss={() => {
        onDismissClicked();
      }}
      type="note"
      disableAnimation
    >
      <Styles.Wrapper>
        <Styles.CopyWrapper>
          <Badge />
          <Text type="h3">
            Reach more people on the world’s most popular video platform.{' '}
          </Text>
          <div>
            <Button
              type="primary"
              size="small"
              label="Connect YouTube"
              onClick={() => {
                window.location.href =
                  'https://account.buffer.com/channels/connect';
              }}
            />
          </div>
        </Styles.CopyWrapper>
        <Styles.IllustrationWrapper />
      </Styles.Wrapper>
    </Layout>
  );
};
